var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 16.5V24.5C26.6667 27.4455 24.2789 29.8333 21.3333 29.8333H10.6667C7.72116 29.8333 5.33334 27.4455 5.33334 24.5V16.5",
    stroke: "#EBD28D",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3583 3.16663H9.64168C7.21854 3.16663 5.03952 4.8263 4.13959 7.35736L3.12895 10.1998C2.82302 11.0602 2.61155 11.9809 2.83469 12.8665C3.36315 14.9636 5.07765 16.5 7.11111 16.5C9.56571 16.5 11.5556 14.2614 11.5556 11.5C11.5556 14.2614 13.5454 16.5 16 16.5C18.4546 16.5 20.4444 14.2614 20.4444 11.5C20.4444 14.2614 22.4343 16.5 24.8889 16.5C26.9223 16.5 28.6369 14.9636 29.1653 12.8665C29.3885 11.9809 29.177 11.0602 28.8711 10.1998L27.8604 7.35735C26.9605 4.8263 24.7815 3.16663 22.3583 3.16663Z",
    stroke: "#EBD28D",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.8334C12 23.6242 13.7909 21.8334 16 21.8334C18.2091 21.8334 20 23.6242 20 25.8334V29.8334H12V25.8334Z",
    stroke: "#EBD28D",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store-icon.e4e8a368aece86f2da7737a56349c5df.svg";
export { ForwardRef as ReactComponent };